<template>
  <div v-if="loaded" class="add-association uk-container">
    <vk-breadcrumb>
      <vk-breadcrumb-item href="/administration">Union Member List</vk-breadcrumb-item>
      <vk-breadcrumb-item v-if="prevPath.includes('members')" :href="'/administration/members/' + memberInfo.bookNum + '/info'">{{memberInfo.fName}} {{memberInfo.lName}}</vk-breadcrumb-item>
      <vk-breadcrumb-item>Add {{formatAssociation(association)}}</vk-breadcrumb-item>
    </vk-breadcrumb>
    <h1>Add Member {{formatAssociation(this.association)}}</h1>
    <h2>{{formatAssociation(this.association)}} Entry</h2>
    <label for="name">Union Member Name</label>
    <p id="name" class="uk-text-bold">{{this.memberInfo.fName + " " + this.memberInfo.lName + " - " + this.bookNum}}</p>
    <form @submit.prevent="postAssociation">
      <label for="date">{{formatAssociation(this.association)}} Date (Required)</label>
      <el-date-picker v-model="date" type="datetime" format="MM/dd/yy hh:mm A"></el-date-picker>
      <label for="description">Description</label>
      <textarea class="uk-textarea" name="" id="description" cols="100" rows="10" v-model="description"></textarea><br>
      <div class="uk-margin-bottom" v-if="this.association === 'bookings'">
        <label for="employed">Currently Employed</label>
        <label for="employed"><input class="uk-checkbox" type="checkbox" id="employed" v-model="employed"> Yes</label>
      </div>
      <input class="uk-button uk-button-primary" type="submit" value="Submit">
    </form>
  </div>
</template>

<script>
import AssociationsApi from "@/utils/api/associations";
import MembersApi from "@/utils/api/members";

export default {
  name: "AddAssociation",
  data() {
    return {
      loaded: false,
      association: this.$route.params.association,
      bookNum: this.$route.query.booknum,
      memberInfo: {},
      date: new Date(),
      description: "",
      employed: false,
      prevPath: "/administration"
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevPath = from.fullPath));
  },
  created() {
    MembersApi.getMember(this.$cookie.get("iwl_apiToken"), this.bookNum).then(
      member => {
        this.memberInfo = member;
        this.loaded = true;
      }
    );
  },
  methods: {
    formatAssociation(text) {
      return text.charAt(0).toUpperCase() + text.slice(1, -1);
    },
    postAssociation() {
      var info = {};
      if (this.association === "bookings") {
        info["currently_employed"] = this.employed;
      }
      info["description"] = this.description;
      info["date"] = new Date();

      AssociationsApi.postAssociation(
        this.$cookie.get("iwl_apiToken"),
        this.association,
        this.bookNum,
        info
      )
        .then(res => {
          console.log(res);
          this.$router.push(this.prevPath);
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style scoped>
.add-association {
  text-align: start;
}
h4 {
  margin-bottom: 0px;
}
input,
textarea {
  margin-bottom: 20px;
}
input[type="checkbox"] {
  margin-bottom: 0px;
}
p {
  margin-top: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/admin_add_association.vue